export const TransitTimesAnalyticsActionTypes = {
    API_RESPONSE_SUCCESS: '@@transit-times-analytics/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@transit-times-analytics/API_RESPONSE_ERROR',
    GET_AVERAGE_DOMESTIC_QUOTED_DAYS: '@@transit-times-analytics/GET_AVERAGE_DOMESTIC_QUOTED_DAYS',
    GET_AVERAGE_DOMESTIC_ACTUAL_DAYS: '@@transit-times-analytics/GET_AVERAGE_DOMESTIC_ACTUAL_DAYS',
    GET_TRANSIT_TIMES_BY_SERVICE_LEVEL: '@@transit-times-analytics/GET_TRANSIT_TIMES_BY_SERVICE_LEVEL',
    GET_TRANSIT_TIMES_BY_TIMEFRAME: '@@transit-times-analytics/GET_TRANSIT_TIMES_BY_TIMEFRAME',
    GET_TRANSIT_TIMES_SUMMARY: '@@transit-times-analytics/GET_TRANSIT_TIMES_SUMMARY',
};
